import {Time} from '@angular/common';

export interface Timeline {
  start: string;
  description: string;
  image: string;
  link: string;
}

export const TIMELINE_UNOX: Timeline[] = [
  {start: '1847',
    description: 'Hartog Hartog wordt geboren in Brakel',
    image: 'assets/img/timeline/hartoghartog.jpg',
    link: undefined
  },

  {start: '1854',
    description: 'Nathan van Zwanenberg wordt geboren in Heesch',
    image: 'assets/img/timeline/nathanvanzwanenberg.jpg',
    link: undefined
  },

  {start: '1872',
    description: 'Hartog trouwt met Marjanna van den Bergh en vertrekt met haar naar Oss.',
    image: undefined,
    link: undefined
  },

  {start: '1875',
    description: 'De broer van Nathan van Zwanenberg, Abraham, verhuist naar Londen. Hiermee ontstaan nieuwe mogelijkheden voor Nathan, die dan momenteel slachter en handelaar is van ‘koosjer’ vlees.',
    image: undefined,
    link: undefined
  },

  {start: '1876',
    description: 'Hartog krijgt een vergunning voor een ‘vleeschouwerij’ aan de Wal in Oss.',
    image: undefined,
    link: undefined
  },

  {start: '1878',
    description: 'Hartog verplaatst zijn bedrijf naar de Heuvel in Oss.',
    image: undefined,
    link: undefined
  },

  {start: '1879',
    description: 'Hartog keert terug naar de Wal.',
    image: undefined,
    link: undefined
  },

  {start: '1883',
    description: 'Hartog verwerkt het vet dat overblijft van varkens na de slacht. Het vet dient als grondstof van margarine, die Hartog doorverkocht aan de Osse margarineproducten.',
    image: undefined,
    link: undefined
  },

  {start: '1884',
    description: 'Hartog verhuist weer, deze keer naar de Peperstraat. De gemeente geeft hem toestemming voor het oprichten van een ‘vleeshouwerij en eene kuiperij’.',
    image: undefined,
    link: undefined
  },

  {start: '1884',
    description: 'Nathan van Zwanenberg huisvest zijn slachterij in een houten schuur in Heesch, een dorp bij Oss.',
    image: undefined,
    link: undefined
  },
  {start: '1887',
    description: 'Zwanenberg vestigt zich in Oss, op het terrein De Rooijen. In 1894 komt ook concurrent Hartog op dit terrein terecht.',
    image: undefined,
    link: undefined
  },
  {start: '1889',
    description: 'Zwanenberg schaft een koelmachine aan. Een behoorlijke stap voorwaarts: voorheen werd het vlees bewaard met natuurijs dat in de winter uit de Maas werd gezaagd en tot de zomer bleef bewaard in kelders. Verder begint Nathan met het maken van bacon. Later zal dit een belangrijk erg exportproduct worden, vooral in de richting van Engeland.',
    image: undefined,
    link: undefined
  },
  {start: '1890',
    description: 'Hartog begint op de Varkensmarkt een vetsmelterij, met een stoomketel en twee smeltbakken. Op dat moment werkt er één medewerker in de smelterij.',
    image: undefined,
    link: undefined
  },
  {start: '1893',
    description: 'Hartog verplaatst zijn slagerij opnieuw. In een leegstaande schuur aan het Heesche Pad maakt Hartog ook voor het eerst eigen zeep, met het vet dat hij uit het vlees wint.',
    image: undefined,
    link: undefined
  },
  {start: '1894',
    description: 'Het bedrijf van Hartog verhuist voor het laatst. Hartog komt terecht op het terrein De Rooijen, dat later de Gasstaat heet. Het gebied is ideaal voor het exporteren van vlees naar het buitenland, omdat er vlakbij een spoor is.',
    image: undefined,
    link: undefined
  },

  {start: '1902',
    description: 'De slagerij, vetfabriek en zeepfabriek van Hartog en Zwanenberg worden uitgebreid met een bloeddrogerij. Hartog benoemt zijn zoon Jacob tot vennoot. Zijn andere zonen volgen later.',
    image: undefined,
    link: undefined
  },
  {start: '1904',
    description: 'Hartog wordt uitgebreid met onder meer een darmenzouterij.',
    image: undefined,
    link: undefined
  },
  {start: '1905',
    description: 'Hartog gaat met zijn gezin in Nijmegen wonen. In die stad zijn betere opleidingsmogelijkheden voor de kinderen. Ook kan hij beter ‘op stand’ wonen.',
    image: undefined,
    link: undefined
  },

  {start: '1908',
    description: 'Zwanenberg registreert het merk ‘Zwaan’, dat in het begin vooral voor eetbare vetten als reuzel wordt gevoerd. In hetzelfde jaar begint Nathan van Zwanenberg ook een borstelfabriek, maar die zal in 1909 alweer door een brand worden verwoest.',
    image: undefined,
    link: undefined
  },
  {start: '1913',
    description: 'De werkliedenvereniging R.K. Skagersgezellenbond St. Joris krijgt in Oss een plaatselijke afdeling.',
    image: undefined,
    link: undefined
  },
  {start: '1914',
    description: 'Arbeiders bij zowel Hartog als Zwanenberg staken. Ze zijn het oneens met de lonen van 1,75 gulden per dag. In totaal staken er bij Zwanenberg 80 arbeiders, bij Hartog 130. Onder andere Hartog gaat niet met de eis akkoord. Een aantal werknemers wordt uiteindelijk ontslagen.',
    image: undefined,
    link: undefined
  },

  {start: '1916',
    description: 'Hartog opent een nieuw kantoorgebouw op het terrein De Rooijen.',
    image: undefined,
    link: undefined
  },
  {start: '1917',
    description: 'Hartog Hartog viert zijn 70ste verjaardag. Het personeel krijgt een halve dag vrij, en één gulden extra salaris. Slechter gaat het bij de buren: in hetzelfde jaar gaat het kantoorpersoneel bij Zwanenberg staken, omdat ze tijdens werktijden niet van hun plek mogen gaan. Zij worden door de directie op staande voet ontslagen.',
    image: undefined,
    link: undefined
  },
  {start: '1918',
    description: 'Zwanenberg koopt een Deens vleestransportbedrijf van Van den Bergh, een margarinefabrikant in Oss. In 1926 zal dit bedrijf weer van de hand worden gedaan vanwege tegenvallende cijfers.',
    image: undefined,
    link: undefined
  },

  {start: '1920',
    description: 'Werkliedenvereniging St. Joris wint aan populariteit onder de arbeiders en sluit voor het eerst een collectieve arbeidsovereenkomst af met zowel Hartog als Zwanenberg. In de  cao staan voor het eerst vaste werktijden: een 45-urige werkweek, met vijf dagen acht uur werk en één dag vijf uur. In hetzelfde jaar neemt Zwanenberg Wijnbergen en Levano’s Exportslachterij in Boxtel over.',
    image: undefined,
    link: undefined
  },
  {start: '1921',
    description: 'Nathan en Arnold van Zwanenberg trekken zich terug uit de directie. De zonen van Arnold, Saal, Arthur en Maurits, nemen het stokje samen met de zoon van Nathan, Ies, over. Nathan sterft hetzelfde jaar, vlak nadat hij met pensioen ging.',
    image: 'assets/img/timeline/arnoldvanzwanenberg.jpg',
    link: undefined
  },
  {start: '1921',
    description: 'Onder druk van de Osse margarineproducten Jurgens en Van den Bergh stopt Zwanenberg met het produceren van margarine. Wel mocht het bedrijf margarine inkopen van de producenten en zelf verkopen in het buitenland.',
    image: undefined,
    link: undefined
  },
  {start: '1923',
    description: 'In Canada werd ontdekt hoe uit de alvleesklieren van dieren insuline kon worden gewonnen. Saal van Zwanenberg richtte daarom in 1923 het Osse Organon op, een dochtermaatschappij van Zwanenberg. Later zou bij dit bedrijf ook de anticonceptiepil worden ontwikkeld.',
    image: undefined,
    link: undefined
  },
  {start: '1925',
    description: 'Hartog gaat meer margarine producten, tot ongenoegen van de Osse margarineproducenten Jurgens en Van den Bergh. De margarinefabriek wordt vergroot.',
    image: undefined,
    link: undefined
  },
  {start: '1926',
    description: 'Hartog Hartog sterft. Zijn zonen nemen het dagelijks bestuur over.',
    image: undefined,
    link: undefined
  },
  {start: '1926',
    description: 'Hartog richt het dochterbedrijf Continentale Industrie en Handel op. Deze onderneming is verantwoordelijk voor de verkoop van vetten in Nederland. Daarnaast exporteert het bedrijf ghee - botervet dat in de tropen veel wordt gebruikt - naar Nederlands-Indië. Hartog heeft zoveel succes met dit bedrijf, dat het evenveel producten verkoopt als de grootste margarineproducten van Oss: Van den Bergh en Jurgens.',
    image: undefined,
    link: undefined
  },

  {start: '1926',
    description: 'Er worden nieuwe afspraken gemaakt tussen margarineproduct Van den Bergh en Zwanenberg. Zwanenberg mag geen margarine meer maken. De familie Van Zwanenberg krijgt een wekelijkse vergoeding.',
    image: undefined,
    link: undefined
  },
  {start: '1927',
    description: 'Jurgens en Van den Bergh fuseren om zo Hartog de loef af te steken. De Margarine Unie is een feit.',
    image: undefined,
    link: undefined
  },
  {start: '1927',
    description: 'Zwanenberg neemt de Uithoornsche Bacon- en Conservenfabriek (UBC) in Uithoorn over.',
    image: undefined,
    link: undefined
  },

  {start: '1928',
    description: 'Hartog gaat de concurrentie met de Margarine Unie, die een jaar eerder werd opgericht, aan. Hij begint met de Hartog-Deutsche Margarine Werke in Kleef, Duitsland.',
    image: undefined,
    link: undefined
  },
  {start: '1928',
    description: 'Het laatste contract tussen Zwanenberg en Van den Bergh uit 1926 verloopt. Zwanenberg mag weer zelf margarine maken.',
    image: undefined,
    link: undefined
  },
  {start: '1929',
    description: 'De Margarine Unie kan de concurrentie met Hartog niet goed meer bijbenen en wil fuseren. Hartog stemt na flinke onderhandelingen toe.',
    image: undefined,
    link: undefined
  },

  {start: '1929',
    description: 'Er duikt ongekeurd vlees (circa 150 kilo) op in de producten van Zwanenberg. Negatieve publiciteit is het gevolg.',
    image: undefined,
    link: undefined
  },
  {start: '1929',
    description: 'De Margarine Unie, waar Hartog sinds hetzelfde jaar deel van uitmaakt, wil de vleesfabrieken van Hartog aan Zwanenberg verkopen, mits Zwanenberg stopt met het produceren van margarine. Saal van Zwanenberg, die sinds 1921 deel uitmaakt van de directie, wijst het aanbod van de hand. <br /><br />Later dat jaar gaat Zwanenberg alsnog overstag. De Margarine Unie biedt het bedrijf jaarlijks een forse vergoeding. In ruil stopt Zwanenberg met de productie van margarine. Hartog blijft, onder de paraplu van de unie, vlees verwerken.<br /><br />Vanwege de productiestop van margarine bij Zwanenberg verliezen ruim 120 werklieden hun baan, zo staat in de krant De Stad Oss. De ontslagen komen zeer ongelegen, omdat Jurgens datzelfde jaar met zijn bedrijf naar Rotterdam vertrekt. Als gevolg daarvan verliezen bij de margarinefabrikant 710 mensen hun baan, een klap voor Oss.',
    image: undefined,
    link: undefined
  },
  {start: '1929',
    description: 'Jurgens en Van den Bergh fuseren met de Britse zeepfabrikant Lever Brothers. De Margarine Unie heet sindsdien Unilever.<br /><br />In oktober slaat de beruchte beurskrach van Wallstreet toe. Dit zorgt voor de komende jaren voor forse problemen en zelfs ontslagen.',
    image: undefined,
    link: undefined
  },
  {start: '1930',
    description: 'Opnieuw doet de Margarine Unie, dat sinds 1929 Unilever heet, Zwanenberg een aanbod. De unie stelt voor dat Hartog en Zwanenberg hun bezittingen in een nieuwe onderneming zouden onderbrengen. De unie zou daarbij een aandeel van 51 procent krijgen, Zwanenberg 49 procent. Saal van Zwanenberg, die in 1921 aan het roer kwam, zou een overwicht in het nieuwe management krijgen.<br /><br />De onderhandelingen duren van maart tot december, totdat Unilever stopt met de gesprekken ‘als gevolg van nieuwe omstandigheden’. Daarmee doelt het bedrijf of de fusie met Lever Brothers een jaar eerder.',
    image: undefined,
    link: undefined
  },

  {start: '1931',
    description: 'Na een moeizaam proces lijkt er alsnog een akkoord te komen tussen Zwanenberg en Unilever. Een zogeheten Vleesch Unie is bijna een feit. Over de onderhandelingen zelf is weinig bekend. Wel zou Zwanenberg niet Hartog overnemen, maar juist worden opgeslokt door Unilever.<br /><br />De hele Zwanenberg-directie gaat akkoord met het voorstel, behalve Ies van Zwanenberg. Hij vindt onder meer dat met een verkoop ‘de toekomst van de Zwanenberg-familie zou worden verkocht’. Het bestuur erkent dat en ziet uiteindelijk af van een verkoop.',
    image: undefined,
    link: undefined
  },
  {start: '1931',
    description: 'In 1931 valt ook de Britse pond. De Nederlandse producten worden te duur voor de Engelse markt, waar veel producten van Unilever en Zwanenberg voor zijn bestemd. Voor Unilever blijkt het voordeliger producten in Engeland te maken, dan ze vanuit Nederland te exporteren. De productie voor Nederland zal alleen nog in Rotterdam plaatsvinden.<br /><br />Als gevolg van de sluiting van de Hartog-margarinefabriek in Oss, worden 529 mensen ontslagen. Voor het resterend personeel neemt het loon af met vijf procent. Dit leidt tot een grote misdaadgolf in Oss, die later bekend zal staan als De bende van Oss. Meer hierover lees je in het verhaal van Ton Langenhuijzen (Historicus I).<br /><br />Bij Zwanenberg is de economische malaise ook merkbaar. Er vallen geen ontslagen, maar kantoormedewerkers moeten vijf tot tien procent van hun loon inleveren.<br /><br />Zwanenberg verkoopt dit jaar net als Unilever minder producten in Engeland. De verkoopafdeling probeert het tij te keren door meer waren aan de man te brengen in gebieden als het Midden-Oosten en Afrika. Maar dat zet uiteindelijk geen zoden aan de dijk.',
    image: undefined,
    link: undefined
  },
  {start: '1932',
    description: 'Unilever besluit bij wijze als kleine pleister 25 mensen aan te nemen voor de productie van ghee, waarmee het bedrijf in 1926 begon.<br /><br />Vanwege de crisis neemt het parlement een wet aan voor het steunen van de varkenshouderij, die in zwaar weer verkeert. Door de ‘Crisis Varkenswet’ moet een zogeheten Varkenscentrale de toevoer en de slacht van varkens in Nederland reguleren. Daarnaast zorgt de centrale voor een vast inkomen van de varkenshouders en slachters.<br /><br />Zwanenberg bedenkt echter een andere noodoplossing. Het bedrijf gaat lokale groenten als spinazie verpakken en verkopen. De oprichting van de Zwanenberg Conservenfabrieken is een feit.<br /><br />Desondanks wil ook Zwanenberg de uurlonen verlagen. Dit zorgt voor felle kritiek van de werknemers, wat bijna uitloopt op een staking. Op het laatste moment weten zowel werkgever als werknemers de ruzie bij te leggen. Er wordt, hetzij minder rigoreus, gekort op de lonen.<br /><br />Al met al blijkt het jaar goed af te lopen voor Zwanenberg, omdat er stakingen plaatsvinden in Denemarken, een grote concurrent. Daarmee kan Zwanenberg genoeg vleesproducten aan onder meer Engeland verkopen.',
    image: undefined,
    link: undefined
  },

  {start: '1933',
    description: 'Vanwege het succesvolle jaar van Zwanenberg, eisen arbeiders opslag van 46 naar 52 cent per uur. De directie wijst deze eis af, en ontslaat zestig medewerkers \'wegens slapte\'.',
    image: undefined,
    link: undefined
  },
  {start: '1934',
    description: 'Saal van Zwanenberg geeft zijn omstreden positie als directeur van de Varkenscentrale op. Hoewel het bestuur van de centrale bestaat uit zeven personen, en hij de leiding van de Zwanenberg Fabrieken heeft overgedragen aan Ies van Zwanenberg, vindt Saal zijn functie onhoudbaar. Meer hierover in de biografie van de familie Van Zwanenberg.<br /><br />In hetzelfde jaar richt Zwanenberg een fabriek op in België, vanwege de protectionistische maatregelen aldaar. Zo kan de Osse vleesverwerker ook actief zijn op de Belgische markt. Zwan in Schoten, zoals de dochteronderneming heet, gaat vanaf dit jaar boterhamworst en buikspek maken.',
    image: undefined,
    link: undefined
  },
  {start: '1935',
    description: 'Dankzij het ingrijpen van de overheid een paar jaar eerder kan Hartog overleven. Voorheen werd gedacht dat het vleesverwerkingsbedrijf de crisis niet zou overleven, omdat Unilever er geen aandacht meer aan zou schenken. Maar het loopt anders. Er wordt dit jaar een bescheiden winst geboekt, mede dankzij de orders van de Varkenscentrale, die een bestelling van tweeduizend ton bacon plaatste.',
    image: undefined,
    link: undefined
  },

  {start: '1936',
    description: 'Het gaat goed met Hartog. Er worden meer vleeswaren gemaakt dan voorheen. De verwerking van harten en levers gebeurt voortaan in eigen fabriek. En de baconproductie neemt toe van 2000 ton in 1935 naar 2859 ton dit jaar. <br /><br />Vanwege de Spaanse burgeroorlog die dit jaar uitbrak, krijgt Hartog veel orders binnen voor rundvlees in blik voor de Spaanse troepen. Reden voor het bedrijf of een nieuwe vleeswarenfabriek in Oss te bouwen op de plek waar voorheen de vetfabriek stond.<br /><br />Ook bij Zwanenberg gaat het dit jaar redelijk. Het bedrijf kan net als Hartog veel naar Spanje exporteren. Massa-ontslagen blijven uit, maar toch worden de uurlonen vanwege de toch nog ongunstige economische omstandigheden met een paar cent verlaagd.',
    image: undefined,
    link: undefined
  },
  {start: '1937',
    description: 'Hartog introduceert de merknaam Unox. De oorsprong van de naam is niet bekend, hoewel wordt aangenomen dat het een samentrekking is van Unilever en het Engelse woord voor os, ‘ox’.<br /><br />In enkele jaren tijd neemt het aantal Unox-artikelen toe. Er komen onder meer rookworsten, talloze soorten ham en theeworst bij. Om de vraag naar bacon bij te blijven, koopt Unilever Pasman’s Fabrieken in Steenwijk. ',
    image: undefined,
    link: undefined
  },
  {start: '1938',
    description: 'Hartog heeft door onbekende oorzaak een kleine dip. De rundvleesproductie staat een tijd stil, arbeiders krijgen wachtgeld. Zij komen echter niet op straat terecht.',
    image: undefined,
    link: undefined
  },

  {start: '1939',
    description: 'Het gaat beter met Hartog. St. Joris noemt de ‘werkzaamheden voor onze leden zeer gunstig’. Wekelijks wordt er 150 ton vlees verwerkt. De baconproductie neemt dit jaar een recordhoogte aan, van 10721 ton. Dat is fors meer dan de 3253 ton van 1937. Op dit moment werken er circa duizend mensen bij Hartog in Oss.<br /><br />Ook bij Zwanenberg is er verbetering zichtbaar. Er worden dit jaar 220.000 dieren geslacht, tegen 180.000 een jaar eerder. Dat is echter minder dan bij Hartog; daar worden 226.000 varkens geslacht.',
    image: undefined,
    link: undefined
  },
  {start: '1940',
    description: 'Duitsland valt Nederland binnen. Hartog en Zwanenberg moeten per direct de export naar andere landen, met name Engeland, staken. De productie neemt drastisch af, en zal het niveau van voor de oorlog niet halen. De bedrijven moeten zich vanaf nu vooral toeleggen op Duitse worstsoorten als blutwurst en bierwurst.<br /><br />De joodse families Van Zwanenberg en Hartog duiken onder. Bij Zwanenberg komt een controleur met absolute macht, een zogeheten Treuhänder, aan het roer. Hartog krijgt daar niet mee te maken, omdat de onderneming als onderdeel van Unilever niet als joods bedrijf wordt gezien.',
    image: undefined,
    link: undefined
  },
  {start: '1943',
    description: 'De productie van allerhande vleeswaren is flink afgenomen. Hartog verwerkt nog maar 3600 ton, veel minder dan bijvoorbeeld in 1939. Om bezig te blijven worden er ook onder andere konijnen en kippen geslacht en verkocht. Ook maakt Hartog wasmiddel, en soep in glas. Andere, nieuwe producten zijn soepblokken en Aromat, een mosselextract. Veel van deze producten blijken later incidenteel en op kleine schaal geproduceerd. Er werken nog 600 mensen, minder dan de 1000 van voor de oorlog.<br /><br />Zwanenberg maakt ook nieuwe producten, waaronder vispastei en visworst. Toch wordt de fabriek dit jaar uiteindelijk stilgelegd. Onder andere de Wehrmacht plaatst geen bestellingen meer. De fabriek houdt zich nu bezig met heg verpakken van vlees van Hartog. De conservenfabriek blijft ondanks de omstandigheden wel actief.',
    image: undefined,
    link: undefined
  },

  {start: '1945',
    description: 'De geallieerden vallen Nederland binnen en blazen een waterpomp op in Nuland. Daardoor komen de Osse inwoners zonder elektriciteit te zitten. Hartog, dat een eigen elektriciteitscentrale heeft, biedt Oss stroom aan.<br /><br />Nederland is in mei bevrijd, en Saal van Zwanenberg neemt vanuit Londen contact op met zijn bedrijven, Zwanenberg en Organon. Hij constateert dat er zuiveringen hebben plaatsgevonden. Later zal hij weer plaatsnemen als directeur.<br /><br />Pas in augustus wordt de vleesverwerking weer opgepakt.',
    image: undefined,
    link: undefined
  },
  {start: '1946',
    description: 'Vanwege het langzaam hervatten van de oude producten, maakt Hartog ook onder andere Unicura-zeep en chloroform. Dit levert werk op voor tientallen mensen.<br /><br />Zwanenberg kan vleesproducten fabriceren voor de Canadese en Amerikaanse troepen in Nederland en daarbuiten. Dit levert tot zeker 1960 werk op. Daarnaast draait de conservenfabriek op volle toeren.',
    image: undefined,
    link: undefined
  },
  {start: '1947',
    description: 'Hartog hervat de export. Orders van het Amerikaanse bezettingsleger in Duitsland en Tjechoslowakije zorgen voor een kleine uitvoer.<br /><br />Zwanenberg richt de N.V. Zwanenberg-Organon op, die de belangen van beide fabrieken in Oss moet behartigen. Verder komt voor Zwanenberg de baconexport naar Engeland weer op gang.',
    image: undefined,
    link: undefined
  },

  {start: '1949',
    description: 'De veestapel is voldoende gegroeid om de vleesproductie weer volledig te hervatten. Voorheen was een beperking van 200 gram per persoon van week. Het aantal slachtingen is dit jaar 65.900 dieren.',
    image: undefined,
    link: undefined
  },
  {start: '1950',
    description: 'Het gaat weer goed met Hartog. Het aantal slachtingen is verdubbeld, naar 133.500. Ook hervat het bedrijf de export naar Engeland.<br /><br />Bij Zwanenberg worden twee keer zoveel varkens geslacht als een jaar eerder: 128.000.<br /><br />Bij Hartog wordt het internationale merk Birds Eye, voor bevroren groenten en fruit, door Unilever ondergebracht. In Europanzijn echter nog niet veel koelkasten, en dus wordt het merk snel weer afgestoten.<br /><br />Hartog begint tevens met de productie en verkoop van Royco (Royal Lipton Company) in Nederland, dat in 1948 werd geïntroduceerd. Het merk Royco vertegenwoordigt tal van zogenoemde droge soepen in poedervorm, waaronder onder andere kippensoep, tomatensoep en erwtensoep.',
    image: undefined,
    link: undefined
  },
  {start: '1951',
    description: 'Unilever, en dus Hartog, brengt Royco onder de aandacht met promotiewagens. Overal in Nederland gaan vertegenwoordigers langs de deuren.',
    image: undefined,
    link: undefined
  },

  {start: '1953',
    description: 'De Royco-soep van Unilever loopt voorspoedig. Hartog bouwt een nieuwe soepfabriek in Oss, die later Unox-soepen zou gaan maken.<br /><br />Voor het eerst sinds 1939 overtreft Hartog het aantal slachtingen. Dit jaar worden er 270.000 varkens in producten verwerkt. De helft van alle vleeswaren is bedoeld voor het buitenland. Het personeelsbestand komt ver boven het niveau van voor de oorlog uit: 1.240 mensen.<br /><br />Ook Zwanenberg overtreft dit jaar het vooroorlogse peil. Er worden dit jaar voor de producten 266.000 varkens geslacht en verwerkt. Zwanenberg en Hartog zijn dit jaar in zowel het aantal slachtingen als het personeelsbestand gelijkwaardig. Bij Zwanenberg werken 1.216 mensen.<br /><br />In 1953 wordt de eerste ondernemingsraad geïnstalleerd, één van de eerste raden binnen het Unilever-concern.',
    image: undefined,
    link: undefined
  },
  {start: '1955',
    description: 'Het aantal slachtingen bij Hartog bedraagt meer dan 300.000, fors meer dan twee jaar geleden.',
    image: undefined,
    link: undefined
  },
  {start: '1956',
    description: 'Unilever stopt in Oss met het slachten van runderen. Het blijkt voordeliger bevroren rundvlees uit Zuid-Amerika in te kopen.',
    image: undefined,
    link: undefined
  },

  {start: '1957',
    description: 'Er werken ruim 2000 mensen bij Hartog, een mijlpaal. In hetzelfde jaar introduceert Unilever de vacuümverpakking van de Unox-rookworst. De rokerij moet daarvoor worden verbouwd.<br /><br />Hartog brengt verder de zogenaamde natte soepen in blik op de markt. Unilever verkoopt deze onder de Unox-vlag.',
    image: undefined,
    link: undefined
  },
  {start: '1958',
    description: 'De Royco-fabriek die in 1953 werd gebouwd, blijkt te klein. Er komt een nieuwe fabriek bij.<br /><br />Zwanenberg neemt dit jaar E. Noack’s Koninklijke Fijne Vleeschwaren- en Conservenfabrieken N.V. over. In het begin zijn het vooral de aandelen. Later worden ook de productie en het personeel gelijkgeschakeld.<br /><br />In hetzelfde jaar breekt bij Zwanenberg een brand uit. Daardoor moet in 1959 een nieuwe vleeswarenfabriek in gebruik worden genomen.',
    image: undefined,
    link: undefined
  },
  {start: '1959',
    description: 'Hartog produceert 66 miljoen Royco-soepzakjes, een hoogtepunt voor het merk dat in 1950 werd geïntroduceerd.<br /><br />Vanwege het succes van de zogeheten natte soepen, kwam de verkooporganisatie van Hartog terug in Oss. Voorheen verkocht Unilever vanuit Rotterdam de soep, terwijl de vestiging in Oss belast was met de productie. Dit jaar verandert dat. Vanuit Oss trekken verkopers het land in.<br /><br />Bij Zwanenberg wordt dit jaar een nieuwe vleeswarenfabriek in gebruik genomen. De oorzaak is een brand, die in 1958 woedde.',
    image: undefined,
    link: undefined
  },

  {start: '1960',
    description: 'Zwanenberg gaat samenwerken met het Noorse Frionorconcern. Daardoor kan het Osse bedrijf naast conservering in glas en blik ook groente invriezen. Dit jaar werken er 1.614 mensen.',
    image: undefined,
    link: undefined
  },
  {start: '1961',
    description: 'Unilever koopt exportslachterij Udema in Gieten, om zo een groter aandeel in de varkensmarkt te krijgen.<br /><br />In dit jaar is tevens een grote staking bij Hartog. Het bedrijf komt ondanks de 2569 medewerkers arbeiders tekort. Zelfs de honderden Belgen die dagelijks op en neer rijden, maken geen verschil. Om ervoor te zorgen dat de productie niet daaronder lijdt, stelt de directie een productiequotum in. <br /><br />Verreweg het grootste deel van de arbeiders legt het werk neer. Dit resulteert in spanningen. De politie moet gewapend met sabels het terrein bewaken. Uiteindelijk bloedt de staking dood.<br /><br />Bij Zwanenberg gaat het daarentegen slechter. Het bedrijf ondervindt last van de dalende baconexport naar Engeland, veroorzaakt door de hoge varkensprijzen. De uitvoer van ham neemt naar de Verenigde Staten neemt wel toe. Daardoor valt het verlies uiteindelijk mee.',
    image: undefined,
    link: undefined
  },
  {start: '1962',
    description: 'Het assortiment Unox-soepen van Hartog beslaat ruim 25 soorten soep. Het marktaandeel bereikt bijna de helft van alle bliksoepen. Om de verkoop op te drijven, krijgt elk Nederlands gezin een gratis blik soep. Dit blijkt succesvol.<br /><br />Wel verliezen in Oss ongeveer honderd mensen hun baan, omdat er minder werd geslacht. De slachterijen van Unilever elders in het land nemen een groot deel van de slachtingen over.',
    image: undefined,
    link: undefined
  },

  {start: '1963',
    description: 'Unilever, en dus Hartog, koopt vleeswaren- en conservenfabriek Olba in Olst. In dit jaar trekt Zwanenberg, net als Hartog twee jaar eerder, Belgen aan om de vraag naar arbeiders te compenseren.',
    image: undefined,
    link: undefined
  },
  {start: '1963',
    description: 'In 1963 treedt Saal van Zwanenberg af als lid en voorzitter van de Raad van Bestuur. Hij blijft aan als adviseur.',
    image: 'assets/img/timeline/saalvanzwanenberg.jpg',
    link: undefined
  },
  {start: '1965',
    description: 'De productie van de Royco-soepen wordt verplaatst van Oss naar Utrecht. De fabriek van Hartog gaat alleen nog Unox-soep maken.<br /><br />In hetzelfde jaar worden honderden Spanjaarden bij Hartog en Zwanenberg aangenomen. Zij moeten de druk op de arbeiders, wat vier jaar een grote staking veroorzaakte, versoepelen.',
    image: undefined,
    link: undefined
  },

  {start: '1965',
    description: 'Om kosten te besparen voegt Zwanenberg de fabrieken van Noack (1958) en de Uithoornsche Bacon- en Conservenfabriek (1927) samen bij de vestiging in Oss.',
    image: undefined,
    link: undefined
  },
  {start: '1965',
    description: 'Zwanenberg legt de groentefabriek stil. Na 33 jaar stopt het bedrijf met het maken van groenteconserven. Daarentegen koopt het vleeswarenbedrijf concurrent Anton Hunink in Deventer.',
    image: undefined,
    link: undefined
  },
  {start: '1965',
    description: 'Zwanenberg en Hartog richten het Varkensonderzoekscentrum Nieuw-Dalland op, voor de veredeling van varkens voor de vleesverwerkende industrie.',
    image: undefined,
    link: undefined
  },

  {start: '1966',
    description: 'Landbouw- en visserijminister Barend Biesheuvel opent de nieuwe slachterij van Zwanenberg, die in de plaats van de voormalige conservenfabriek is gekomen. De nieuwe slachterij behoort naar verluidt tot de grootste en modernste in zijn soort.',
    image: undefined,
    link: undefined
  },
  {start: '1967',
    description: 'Zwanenberg, of beter Koninklijke Zwanenberg-Organon, fuseert met Koninklijke Zout-Ketjen. De nieuwe naam wordt Koninklijke Zout-Organon (KZO), de voorloper van AKZO (1969). ‘Zwanenberg’ verdween als naam volledig.<br /><br />De Koninklijke Zout-Ketjen legt zich toe op met name de fabricage van zout. Maar ook chemische producten, lakken en verven speelden een belangrijke rol.<br /><br />Slechts twintig procent van de producten bestaat nog uit voedingsmiddelen. Het totaal aantal medewerkers komt uit op 24.600 (17.100 in Nederland). Het aantal voormalige Zwanenberg-medewerkers die zich bezighouden met het verwerken van vlees, bedraagt slechts 3.500 mensen.',
    image: undefined,
    link: undefined
  },
  {start: '1968',
    description: 'Zwanenberg slacht in één jaar meer dan 400.000 varkens, een record. Dit jaar werken er liefst 2.150 mensen bij het bedrijf. Bij de overgenomen ondernemingen Noack (1958), UBC (1927) en Hunink (1965) werken bovendien liefst 1.250 mensen.',
    image: undefined,
    link: undefined
  },

  {start: '1969',
    description: 'Koninklijke Zout-Organon, dat in 1967 ontstond als een fusie tussen Zwanenberg-Organon en Zout-Ketjen, gaat samen met de Algemene Kunstzijde Unie (AKU). De AKU is een producent van chemische vezels en kunststoffen. Het nieuwe concern heet AKZO. ',
    image: undefined,
    link: undefined
  },
  {start: '1970',
    description: 'Omdat Zwanenberg als een vreemde eet in de bijt wordt gezien na de fusie een jaar eerder, zoekt AKZO een overnamekandidaat. In 1970 wordt die gevonden. Unilever en de vleeswarentak Zwanenberg fuseren in maart 1970.<br /><br />Bij de bedrijven Unox (Hartog), Zwanenberg en alle overgenomen bedrijven werken op het moment van de overname precies 6.212 mensen. De twee bedrijven gaan onder de Unilever Vlees Groep (UVG) verder als Unox N.V., Zwan (de Belgische tak van Zwanenberg, opgericht in 1934) en Zwanenberg N.V. Hoe dat precies in zijn werk gaat, staat in het verhaal van Ton Langenhuijzen (Historicus I).',
    image: undefined,
    link: undefined
  },
  {start: '1972',
    description: 'Vanwege de reorganisatie door de fusie in 1970 sluit Anton Hunink, dat Zwanenberg in 1965 overnam, in Deventer.',
    image: undefined,
    link: undefined
  },

  {start: '1974',
    description: 'UVG, dat in 1970 ontstond na een fusie van Unox (Hartog) en Zwanenberg, maakt een miljoenenverlies. Eén van de oorzaken is de afgenomen export van hammen naar de Verenigde Staten. De VS verbiedt de Nederlandse ham, omdat er een te hoog gehalte aan de pesticide HCB in zit. In de jaren die volgen worden als gevolg daarvan UVG-bedrijven afgestoten en medewerkers ontslagen. Dit jaar sluit onder meer Noack.',
    image: undefined,
    link: undefined
  },
  {start: '1977',
    description: 'De slachterijen van Zwanenberg en Unox worden vanwege de bezuinigingen samengevoegd. Ongeveer 110 arbeidsplaatsen gaan verloren. De moderne Zwanenberg-slachterij, die in 1966 nog werd geopend, gaat dicht. Daarnaast moeten er op andere plekken binnen de Osse vestiging banen verdwijnen. ',
    image: undefined,
    link: undefined
  },
  {start: '1979',
    description: 'Olba in Olst (1963) en UBC in Uithoorn (1927) gaan vanwege de bezuinigingen dicht. In totaal verdwijnen er door de reorganisaties sinds de fusie in 1970 bij de Unilever Vlees Groep 1800 van de 4500 banen.',
    image: undefined,
    link: undefined
  },

  {start: '1982',
    description: 'De UVG komt maar niet uit de rode cijfers. Ook is de slachtcapaciteit te groot geworden. Er wordt daarom besloten de slachterij in Oss aan het einde van het jaar te sluiten. Er wordt alleen nog maar geslacht bij Udema in Gieten, dat Unilever in 1961 kocht.',
    image: undefined,
    link: undefined
  },
  {start: '1992',
    description: 'Udema in Gieten, dat Unilever in 1961 overnam, wordt gesloten. Ruim 170 medewerkers belanden op straat. Drie jaar later zal de slachterij definitief verdwenen zijn.',
    image: undefined,
    link: undefined
  },
  {start: '1995',
    description: 'De UVG ontslaat driehonderd medewerkers in Oss. Ook wordt de Zwan-fabriek, die in 1934 werd opgericht door Zwanenberg, verkocht aan het bedrijf Meatpoint. Op dit moment werken er door de reorganisaties de afgelopen jaren nog ‘slechts’ zeshonderd mensen in Oss.',
    image: undefined,
    link: undefined
  },

  {start: '1997',
    description: 'De Unilever Vlees Groep (UVG) fuseert met Van den Bergh, beide dochterondernemingen van Unilever. De bedrijven gaan verder onder de naam Van den Bergh Nederland.<br /><br />Van den Bergh, ontstaan uit de gelijknamige margarinefabrikant die in 1927 de Margarine Unie begon in Oss, omvat onder andere de merken Blue Band. <br /><br />Als gevolg van de fusie worden er bij zowel UVG als Van den Bergh zeventig mensen ontslagen. In Oss verdwijnen tevens vijftig extra banen. Het gaat vooral om leidinggevende en ondersteunende functies.',
    image: undefined,
    link: undefined
  },

  {start: '2007',
    description: 'Organon, een zelfstandig bedrijf binnen AkzoNobel, wordt door het Amerikaanse Shering-Plough gekocht. ',
    image: undefined,
    link: undefined
  },

  {start: '2009',
    description: 'Het Amerikaanse Shering-Plough, dat in 2007 Organon kocht, fuseert met Merck & Co. en heet sindsdien MSD',
    image: undefined,
    link: undefined
  },

  {start: '2010',
    description: 'Na ruim tien jaar op een personeelsbestand van 450 medewerkers gezeten te hebben, slankt Unox in Oss opnieuw af. Er verdwijnen 95 banen. De ontslagen zijn nodig om kosten te besparen, en zo ‘concurrerend te blijven’.',
    image: undefined,
    link: undefined
  },

  {start: '2010',
    description: 'In 2010 wordt duidelijk dat MSD, dat in 2009 ontstond na een fusie en eigenaar is van het voormalige Organon en AKZO (1967), 1600 mensen ontslaat. In de panden die leeg komen te staan, komen nieuwe bedrijven: het zogeheten Life Sciences Park.',
    image: undefined,
    link: undefined
  },

  {start: '2011',
    description: 'De productielijn van soep-in-zak gaat van Unox in Oss naar een Unilever-fabriek in Polen. Aanleiding is het beter ‘stroomlijnen’ van het bedrijf, aldus de directie. In Oss worden nog soep-in-blik en worsten gefabriceerd.',
    image: undefined,
    link: undefined
  },
  {start: '2015',
    description: 'Het Osse bedrijf Bionovion, dat na de reorganisatie van MSD (2010) in 2011 is ontstaan, verwacht dit jaar het eerste medicijn tegen kanker in productie te kunnen nemen.',
    image: undefined,
    link: undefined
  }
];
